import { render, staticRenderFns } from "./article-edit.vue?vue&type=template&id=75aff0fe&scoped=true&"
import script from "./article-edit.vue?vue&type=script&lang=js&"
export * from "./article-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75aff0fe",
  null
  
)

export default component.exports